import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import svelteComponent from "./MediaObjectCardV2.svelte";

defineComponent({
  tag: "oc-media-object-card-v2",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: () => import("./MediaObjectCardV2.global.scss?inline"),
  props: {
    elevationLevel: { type: "String", attribute: "elevation-level", reflect: true },
    icon: { type: "String", reflect: true },
    inverted: { type: "Boolean", reflect: true },
    preferVerticalAlignment: {
      type: "Boolean",
      attribute: "prefer-vertical-alignment",
      reflect: true,
    },
    singleLine: { type: "Boolean", attribute: "single-line", reflect: true },
    size: { type: "String", reflect: true },
    variant: { type: "String", reflect: true },
    widthBehavior: { type: "String", attribute: "width-behavior", reflect: true },
  },
  component: svelteComponent,
});
